module.exports = __webpack_public_path__ + "img/mail-large.3e32e125.svg";